import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { createFilter } from 'redux-persist-transform-filter'
import storage from 'redux-persist/lib/storage'
import AppConfig from './AppConfig'

//App reducers
import reducers from '../stores/reducers'

//App epics
import epics from '../stores/epics'

//History
import { createBrowserHistory } from 'history'
const history = createBrowserHistory({ basename: AppConfig.BASEPATH });

//Filter state to store/blacklist.
//By default, anything missing below *will* be persisted.
//Anything in the list, will not be persisted, unless a specific key is in the array.
//Example: createFilter('app', []) - Nothing will be persisted for anything in 'app'
//Example: createFilter('app', ['some_field']) - Only 'some_field' will be persisted
const filters = [
  createFilter('auth', [])
];

//Middleware
import { createEpicMiddleware } from 'redux-observable'
import { connectRouter, routerMiddleware } from 'connected-react-router'
const epicMiddleware = createEpicMiddleware();
const middleware = applyMiddleware(epicMiddleware, routerMiddleware(history));

//Persist config
const persistConfig = {
  key: 'bevspot-auth',
  storage,
  transforms: [...filters],
};

const initialState = {};
const persistedReducer = persistReducer(persistConfig, reducers);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  connectRouter(history)(persistedReducer),
  initialState,
  composeEnhancers(middleware),
);
const persistor = persistStore(store);

epicMiddleware.run(epics);

export { store, persistor, history }
